import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import Container from 'components/v2/container';
import { Popover, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { humanize, titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import classnames from 'classnames';
import EquipmentSearch from 'components/modules/orders/equipments/EquipmentSearch';
import DataList from 'components/ui/DataList';
import DataPoller from 'components/ui/DataPoller';
import EditEquipmentModal from 'components/modules/equipment/EditEquipmentModal';
import AddEquipmentModal from 'components/modules/equipment/AddEquipmentModal';
import Badge from 'components/ui/Badge';
import { withLocaleContext } from 'providers/locale-settings-context';
import BulkEditEquipmentModal from './BulkEditEquipmentModal';
import CargomaticInput from '../../v2/input';
import EquipmentActionCreators from '../../../actions/EquipmentActionCreators';
import EquipmentStore from '../../../stores/EquipmentStore';
import FilterGroup from './FilterGroup';
import Filters from './Filters';
import SessionStore from '../../../stores/SessionStore';
import Mapping from './Mapping';
import EquipmentCSVExporter from './EquipmentCSVExporter';
const DATE_FIELDS = [
    'last_free_date',
    'last_cut_date',
    'earliest_empty_date',
    'earliest_return_date',
];
const getFiltersWithoutDates = (filters) => {
    const dateFields = [];
    DATE_FIELDS.forEach((field) => {
        dateFields.push(`${field}_start_date`);
        dateFields.push(`${field}_end_date`);
    });
    return _.omit(filters, dateFields);
};
class List extends Component {
    constructor(props) {
        super(props);
        this.filterSelectedEquipment = () => {
            return this.state.equipment.filter((e) => this.state.selectedEquipmentIds.includes(e._id));
        };
        this.handleToggleFilters = () => {
            this.setState((prevState) => ({
                filtersToggled: !prevState.filtersToggled,
            }));
        };
        this.mapColumnHeaders = (columns) => {
            const { t } = this.props;
            return columns.map((column) => {
                var _a;
                const mapped = Object.assign(Object.assign({}, column), { headerText: column.dataField === 'shipment'
                        ? t(column.localizationSlug, { count: 1 })
                        : t(column.localizationSlug) });
                if (column.type === 'datetime') {
                    mapped.formatExtraData = {
                        locale: (_a = this.props.localeData) === null || _a === void 0 ? void 0 : _a.languageCodeId,
                    };
                }
                return mapped;
            });
        };
        this.handleRemoveEquipment = (id) => () => {
            this.setState((prevState) => {
                const filters = _.cloneDeep(prevState.filters);
                filters.equipment = filters.equipment.filter((c) => c !== id);
                const metaData = _.cloneDeep(prevState.metaData);
                delete metaData.equipment[id];
                return {
                    metaData,
                    filters,
                };
            });
        };
        this.handleShowBulkEditModal = () => this.setState({
            showBulkEditModal: true,
            selectedEquipment: this.filterSelectedEquipment(),
        });
        this.handleHideBulkEditmodal = () => this.setState({
            showBulkEditModal: false,
            bulkActionDisabled: true,
            selectedEquipmentIds: [],
        });
        this.handleDropdownSelect = (groupId) => (e) => {
            this.setState((prevState) => {
                const filters = _.cloneDeep(prevState.filters);
                filters[groupId] = e.target.value;
                return { filters };
            });
        };
        this.handleColumnToggle = (dataField) => (checked) => {
            const hidden = !checked;
            this.setState((currentState) => {
                let hiddenColumns = [...currentState.hiddenColumns];
                if (hidden) {
                    hiddenColumns.push(dataField);
                }
                else {
                    hiddenColumns = hiddenColumns.filter((c) => c !== dataField);
                }
                return {
                    hiddenColumns,
                };
            }, () => SessionStore.setEquipmentUserColumnPreferences(this.state.hiddenColumns));
        };
        this.handleEquipmentStoreChange = () => {
            const equipmentPayload = EquipmentStore.getEquipmentPayload();
            this.setState({
                equipment: equipmentPayload.equipment.map((e) => (Object.assign(Object.assign({}, e), { onClick: () => {
                        this.setState({ showEditEquipmentModal: true, selectedEquipment: e });
                    } }))),
                pages: equipmentPayload.pages,
                totalEntries: equipmentPayload.total,
            });
        };
        this.handleFilterApply = () => {
            this.buildFilters();
            this.fetchEquipment();
        };
        this.handleFilterChange = (groupId) => (value) => (checked) => {
            this.setState((prevState) => {
                const { filters: currentFilters } = prevState;
                const filters = Object.assign({}, currentFilters);
                const index = filters[groupId].findIndex((f) => f === value);
                if (index !== -1 && !checked) {
                    filters[groupId] = [
                        ...filters[groupId].slice(0, index),
                        ...filters[groupId].slice(index + 1),
                    ];
                    return { filters };
                }
                if (index === -1 && checked) {
                    filters[groupId].push(value);
                    return { filters };
                }
                return null;
            });
        };
        this.handleDateChange = (groupId) => (date) => {
            this.setState((prevState) => {
                const { filters: currentFilters } = prevState;
                const filters = Object.assign({}, currentFilters);
                filters[groupId] = date;
                return { filters };
            });
        };
        this.handleDateSelect = (groupId) => (date) => {
            this.setState((prevState) => {
                const { filters: currentFilters } = prevState;
                const filters = Object.assign({}, currentFilters);
                filters[groupId] = date;
                return { filters };
            });
        };
        this.handleEquipmentSelect = (value) => {
            this.setState((prevState) => {
                const filters = _.cloneDeep(prevState.filters);
                const metaData = _.cloneDeep(prevState.metaData);
                const id = value._id;
                filters.equipment = [...filters.equipment, id];
                metaData.equipment[id] = value.equipment_id;
                return {
                    metaData,
                    filters,
                };
            });
        };
        this.fetchEquipment = () => {
            EquipmentActionCreators.getAllEquipment(Object.assign({ populate: [
                    { path: 'owner', select: 'company_name _type' },
                    { path: 'shipment', select: 'shipment_id' },
                    { path: 'current_shipment', select: 'shipment_id' },
                    { path: 'order', select: 'order_id order_type status' },
                    {
                        path: 'chassis_owner',
                        select: 'name company_name _type first_name last_name',
                    },
                ] }, getFiltersWithoutDates(this.state.filters)));
        };
        this.handleSelection = (equipmentToSelect, checked) => {
            this.setState((prevState) => {
                const { equipment, selectedEquipmentIds: currentSelectedEquipmentIds } = prevState;
                let selectedEquipmentIds;
                if (checked) {
                    selectedEquipmentIds = [
                        ...currentSelectedEquipmentIds,
                        equipmentToSelect._id,
                    ];
                }
                else {
                    const index = currentSelectedEquipmentIds.findIndex((e) => e === equipmentToSelect._id);
                    if (index !== -1) {
                        selectedEquipmentIds = [
                            ...currentSelectedEquipmentIds.slice(0, index),
                            ...currentSelectedEquipmentIds.slice(index + 1),
                        ];
                    }
                    else {
                        selectedEquipmentIds = [...currentSelectedEquipmentIds];
                    }
                }
                const bulkActionDisabled = selectedEquipmentIds.length === 0;
                const selectedEquipment = equipment.filter((e) => selectedEquipmentIds.includes(e._id));
                return {
                    selectedEquipmentIds,
                    selectedEquipment,
                    bulkActionDisabled,
                };
            });
        };
        this.handleSelectAll = (checked) => {
            this.setState((prevState) => {
                const { equipment } = prevState;
                let selectedEquipment = [];
                let selectedEquipmentIds = [];
                let bulkActionDisabled = true;
                if (checked) {
                    selectedEquipment = [...equipment];
                    selectedEquipmentIds = selectedEquipment.map((s) => s._id);
                    bulkActionDisabled = true;
                }
                return {
                    bulkActionDisabled,
                    selectedEquipmentIds,
                    selectedEquipment,
                };
            });
        };
        this.handlePaginationSelect = (page) => {
            this.setState((prevState) => {
                const filters = _.cloneDeep(prevState.filters);
                const pageIndex = filters[page];
                if (_.isEmpty(pageIndex)) {
                    filters.page = page;
                    filters.paginate = true;
                    // filters.push({ id: 'page', value: page });
                    // filters.push({id: 'paginate', value: true});
                }
                else {
                    filters.page = page;
                    // filters[pageIndex].value = page;
                }
                return { filters, currentPage: page };
            }, () => this.fetchEquipment());
        };
        const hiddenColumns = SessionStore.getEquipmentUserColumnPreferences()
            .concat(Mapping.columns)
            .filter((c) => c.disabled)
            .map((c) => c.dataField);
        this.state = {
            bulkActionDisabled: true,
            showAddEquipmentModal: false,
            showBulkEditModal: false,
            showEditEquipmentModal: false,
            equipment: [],
            filtersToggled: false,
            filters: {
                equipment: [],
                status: [],
                page: 1,
                per_page: 50,
                paginate: true,
                sort_by: '_id',
                order: 'desc', // Questionable here but server side expects order currently.
            },
            metaData: {
                equipment: {},
            },
            selectedEquipment: [],
            selectedEquipmentIds: [],
            pages: 1,
            currentPage: 1,
            totalEntries: 0,
            hiddenColumns: _.uniq(hiddenColumns),
        };
    }
    componentDidMount() {
        EquipmentStore.addChangeListener(this.handleEquipmentStoreChange);
        this.fetchEquipment();
    }
    componentWillUnmount() {
        EquipmentStore.removeChangeListener(this.handleEquipmentStoreChange);
    }
    getColumnList() {
        const { t } = this.props;
        const hiddenColumns = this.state.hiddenColumns;
        return Mapping.columns
            .filter((c) => !c.disabled && c.dataField !== 'equipment_id')
            .map((column) => ({
            dataField: column.dataField,
            text: titleize(t(column.localizationSlug, { count: (column === null || column === void 0 ? void 0 : column.count) || 1 })),
            hidden: hiddenColumns.includes(column.dataField),
        }));
    }
    buildFilters() {
        this.setState((prevState) => {
            const { filters } = prevState;
            filters.dates = {};
            DATE_FIELDS.forEach((field) => {
                const start = filters[`${field}_start_date`];
                const end = filters[`${field}_end_date`];
                if (start || end) {
                    filters.dates[field] = {};
                    if (start) {
                        filters.dates[field].start_date = start.toISOString();
                    }
                    if (end) {
                        if (!start) {
                            filters.dates[field].start_date = end.toISOString();
                        }
                        else {
                            filters.dates[field].end_date = end.toISOString();
                        }
                    }
                }
            });
            return { filters };
        });
    }
    saveEquipment(equipEntity) {
        EquipmentActionCreators.addEquipment(equipEntity);
    }
    updateEquipment(equipment) {
        EquipmentActionCreators.updateEquipment(equipment);
    }
    renderDateFilter(filterGroup) {
        const selected = this.state.filters[filterGroup.id];
        return (React.createElement("div", { className: "block mt-4 mb-4 date-filter" },
            React.createElement(DatePicker, { selected: selected, className: "w-full form-field", placeholderText: filterGroup.title, onChange: this.handleDateChange(filterGroup.id), isClearable: true, onSelect: this.handleDateSelect(filterGroup.id) })));
    }
    renderDateRange(filterGroup) {
        const { t } = this.props;
        const { id } = filterGroup;
        return (React.createElement("div", null,
            this.renderDateFilter(Object.assign(Object.assign({}, filterGroup), { id: `${id}_start_date`, title: t('START_DATE') })),
            this.renderDateFilter(Object.assign(Object.assign({}, filterGroup), { id: `${id}_end_date`, title: t('END_DATE') }))));
    }
    renderColumnList() {
        return (React.createElement(Popover, { id: "order-columns", bsStyle: "popover max-w-md" },
            React.createElement("div", { className: "space-y-2" }, this.getColumnList().map((col) => {
                const checked = !col.hidden;
                return (React.createElement(CargomaticInput, { id: col.dataField, key: col.dataField, type: "checkbox", onChange: this.handleColumnToggle(col.dataField), label: col.text, checked: checked, applyDefaultMargins: false }));
            }))));
    }
    renderEquipmentFilter() {
        return (React.createElement("fieldset", null,
            React.createElement("div", { className: "mb-4 customer-search" },
                React.createElement(EquipmentSearch, { onEquipmentSelect: this.handleEquipmentSelect }),
                React.createElement("div", { className: "my-4 selected" }, this.renderSelectedEquipment()))));
    }
    renderSelectedEquipment() {
        return this.state.filters.equipment.map((c) => {
            const label = this.state.metaData.equipment[c];
            if (!label) {
                return (React.createElement(Badge, { text: c, key: c, onClick: this.handleRemoveEquipment(c) }));
            }
            return (React.createElement(Badge, { text: label, key: c, onClick: this.handleRemoveEquipment(c) }));
        });
    }
    renderDropdownFilter(filterGroup) {
        const id = filterGroup.id;
        return (React.createElement("select", { value: this.state.filters[id], className: "form-select", key: id, onChange: this.handleDropdownSelect(filterGroup.id) },
            React.createElement("option", { value: "" }, "Select an option"),
            filterGroup.filters.map((filter) => {
                if (typeof filter === 'object') {
                    return (React.createElement("option", { value: filter.value, key: filter.value }, filter.name));
                }
                return (React.createElement("option", { value: filter, key: filter }, humanize(filter)));
            })));
    }
    renderFilterGroup(filterGroup) {
        if (filterGroup.type === 'date') {
            return this.renderDateFilter(filterGroup);
        }
        if (filterGroup.type === 'equipment') {
            return this.renderEquipmentFilter(filterGroup);
        }
        if (filterGroup.type === 'dropdown') {
            return this.renderDropdownFilter(filterGroup);
        }
        if (filterGroup.type === 'text') {
            return this.renderTextFilter(filterGroup);
        }
        if (filterGroup.type === 'date_range') {
            return this.renderDateRange(filterGroup);
        }
        const renderedFilters = filterGroup.filters.map((filter) => this.renderFilter(filterGroup.id, filter));
        return renderedFilters;
    }
    renderFilter(groupId, filter) {
        const filters = this.state.filters[groupId] || [];
        return (React.createElement(CargomaticInput, { key: filter, id: filter, type: "checkbox", checked: filters.includes(filter), onChange: this.handleFilterChange(groupId)(filter), label: this.renderStatusSlug(filter) }));
    }
    renderStatusSlug(filter) {
        const { t } = this.props;
        const pluralSlugArr = ['available', 'unavailable'];
        if (pluralSlugArr.includes(filter)) {
            return titleize(t(filter.toUpperCase(), { count: 1 }));
        }
        return titleize(t(filter.toUpperCase()));
    }
    renderFilterGroups() {
        const { t } = this.props;
        return Filters.map((filterGroup) => {
            const title = t(filterGroup.localizedTitle);
            const groupId = filterGroup.id;
            const renderedFilterGroup = this.renderFilterGroup(filterGroup);
            return (React.createElement(FilterGroup, { title: title, key: groupId }, renderedFilterGroup));
        });
    }
    render() {
        const { currentPage, filters: { per_page } } = this.state;
        const { t } = this.props;
        let x;
        if (currentPage === 1) {
            x = currentPage;
        }
        else {
            x = (this.state.currentPage - 1) * per_page + 1;
        }
        let y;
        if (x === 1) {
            y =
                this.state.totalEntries < per_page ? this.state.totalEntries : per_page;
        }
        else if (this.state.totalEntries > 0) {
            const count = x + 1 + per_page;
            y = count < this.state.totalEntries ? count : this.state.totalEntries;
        }
        else {
            y = 0;
        }
        const filterButtonClass = classnames({
            button: true,
            'button-circle': true,
            'button-green': this.state.filtersToggled,
            'button-hollow-green': !this.state.filtersToggled,
            'mr-2': true,
            flex: true,
            block: true,
            'items-center': true,
        });
        const mainClassName = classnames({
            'w-full': true,
            'md:w-3/4': this.state.filtersToggled,
        });
        const bulkEditTooltip = (React.createElement(Tooltip, { id: "bulk-edit-tooltip" }, t('SELECT_MULTIPLE_EQUIPMENT_TIP')));
        return (React.createElement(Container, null,
            React.createElement("div", { className: "mt-10" },
                React.createElement("div", { className: "equipment" },
                    React.createElement(DataPoller, { action: () => this.fetchEquipment() }),
                    React.createElement("div", { className: "flex flex-wrap items-center justify-between p-4 bg-white" },
                        React.createElement("div", { className: "flex items-center left-section" },
                            React.createElement("button", { className: filterButtonClass, title: t('TOGGLE_FILTERS'), onClick: this.handleToggleFilters },
                                React.createElement("span", { className: "fa fa-filter" })),
                            React.createElement(OverlayTrigger, { overlay: this.renderColumnList(), placement: "bottom", trigger: "click" },
                                React.createElement("button", { className: "flex items-center button button-hollow-green" },
                                    React.createElement("i", { className: "mr-2 fa fa-columns" }),
                                    React.createElement("span", null, t('COLUMN', { count: 1 }))))),
                        React.createElement("div", { className: "flex right-section" },
                            React.createElement("button", { type: "button", title: t('ADD_EQUIPMENT'), className: "mr-2 button button-green", onClick: () => this.setState({ showAddEquipmentModal: true }) },
                                React.createElement("i", { className: "mr-2 fa fa-plus" }),
                                titleize(t('EQUIPMENT'))),
                            React.createElement(OverlayTrigger, { placement: "top", overlay: bulkEditTooltip },
                                React.createElement("div", { className: classnames({
                                        'cursor-pointer': this.state.bulkActionDisabled,
                                    }) },
                                    React.createElement("button", { type: "button", disabled: this.state.bulkActionDisabled, className: "mr-2 button button-hollow-green", onClick: this.handleShowBulkEditModal }, t('BULK_EDIT')))),
                            React.createElement("div", { className: "mr-2" },
                                React.createElement(EquipmentCSVExporter, { filters: this.state.filters, columns: this.state.activeColumns }))))),
                React.createElement("div", { className: "flex flex-wrap equipment-section" },
                    this.state.filtersToggled && (React.createElement("div", { className: "w-full filters-sidebar bg-grey-lightest md:w-1/4" },
                        React.createElement("div", { className: "p-4" },
                            React.createElement("h4", null, t('FILTER', { count: 2 })),
                            this.renderFilterGroups()),
                        React.createElement("button", { className: "float-right my-4 mr-4 button button-green", onClick: this.handleFilterApply }, titleize(t('APPLY'))))),
                    React.createElement("div", { className: mainClassName },
                        React.createElement(DataList, { showHeaders: true, select: true, selected: this.state.selectedEquipmentIds, hover: true, striped: true, data: this.state.equipment, columns: this.mapColumnHeaders(Mapping.columns), hiddenColumns: this.state.hiddenColumns, perPage: this.state.filters.per_page, pages: this.state.pages, page: this.state.currentPage, total: this.state.totalEntries, paginate: true, onPaginationSelect: (page) => this.handlePaginationSelect(page), onSelect: (selectedEquipment, checked) => {
                                this.handleSelection(selectedEquipment, checked);
                            }, onSelectAll: (checked) => this.handleSelectAll(checked) }))),
                this.state.showEditEquipmentModal && (React.createElement(EditEquipmentModal, { show: this.state.showEditEquipmentModal, onHide: () => this.setState({ showEditEquipmentModal: false }), equipment: this.state.selectedEquipment, onSave: this.updateEquipment })),
                this.state.showAddEquipmentModal && (React.createElement(AddEquipmentModal, { show: this.state.showAddEquipmentModal, onHide: () => this.setState({ showAddEquipmentModal: false }), onSave: this.saveEquipment })),
                this.state.showBulkEditModal && (React.createElement(BulkEditEquipmentModal, { show: this.state.showBulkEditModal, onHide: this.handleHideBulkEditmodal, equipments: this.state.selectedEquipment })))));
    }
}
export default withTranslation()(withLocaleContext(List));
